import React from 'react'
import CtaButton from '../Button/index'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const ButtonWrapper = styled.div`
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  padding-bottom: 1em;
  max-width: 225px;
  a {
    border: solid 2px #fff;
    padding: 10px 28px;
  }
`

const getComponentType = (href, linkComponent) => {
  // no href, return as a button
  if (!href) return 'button'
  // if external, render an a
  //if (isExternalLink(href)) return 'a'
  // otherwise, attempt to render custom linkComponent, fall back to a
  return linkComponent || 'a'
}

const Button = ({ handleClick, href, linkComponent, text, to }) => {
  return (
    <ButtonWrapper>
      <CtaButton
        as={getComponentType(href, linkComponent)}
        fullWidth={['xs', 'sm', 'md']}
        href={href}
        onClick={handleClick}
        //rel={target === '_blank' ? 'noopener noreferrer' : null}
        //target={target}
        to={to}
      >
        {text}
      </CtaButton>
    </ButtonWrapper>
  )
}

Button.propTypes = {
  text: PropTypes.string,
  href: PropTypes.string,
  handleClick: PropTypes.func,
  to: PropTypes.string,
}

export default Button
